import React, { Component } from "react";
import $ from "jquery";
import { Link, Route } from "react-router-dom";
import { apiCalling } from "../apiService";
import Twitter from "../image/theme/twitter-12.png";
import Facebook from "../image/theme/facebook-sm.png";
import Pinterest from "../image/theme/pinterest-sm.png";
import Instagram from "../image/theme/instagram-sm.png";
import Youtube from "../image/theme/youtube (1).png";
// import Whatsapp from "../image/theme/whatsapp.png";
import Whatsapp from "../adminManagement/pharmaAdAproval/whatsapp";
import InnerHTML from "dangerously-set-html-content";

const phone =
  "https://s3.ap-south-1.amazonaws.com/wl.purplehealth.com/image/dentaldesigns/phone.png";
const address =
  "https://s3.ap-south-1.amazonaws.com/wl.purplehealth.com/image/dentaldesigns/address.png";
const hours =
  "https://s3.ap-south-1.amazonaws.com/wl.purplehealth.com/image/dentaldesigns/wall-clock.png";

export default class footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      footerDetails: [],
      hospitalData: [],
      hospitalDataLength: 0,
      footerData: [],
    };
  }

  componentDidMount() {
    const hospitalData = JSON.parse(
      window.sessionStorage.getItem("footerhospitalData")
    );
    const footerData = JSON.parse(window.sessionStorage.getItem("footerData"));
    if (footerData) {
      this.setState({ footerData: footerData });
    }
    if (hospitalData) {
      this.setState({ hospitalData: hospitalData });
      this.setState({ hospitalDataLength: hospitalData.length });
    } else {
    }
  }

  componentWillMount() {
    const footerList = {
      method: "POST",
      body: JSON.stringify({
        functionName: "getFooterLinks",
        groupHospitalAdminId: window.sessionStorage.getItem(
          "groupHospitalAdminId"
        ),
      }),
    };

    apiCalling(footerList).then((data) => {
      if (data.success == "1") {
        this.setState({ footerDetails: data.footerLinkData });
      }
    });
  }

  render() {
    const urlPath = window.location.origin.toString();

    function top() {
      $("html, body").animate({ scrollTop: 0 }, "slow");
    }

    return (
      <div class="metalFooter">
        <div class="footerTop">
          {this.state.hospitalData.map((obj) => {
            //var location=obj.hospitalName+"+"+obj.cityName+"+"+obj.stateName+"+"+obj.zipCode
            var location =
              obj.googleAddressPin === ""
                ? obj.latitude + "," + obj.longitude
                : obj.googleAddressPin;
            return (
              <div
                class={
                  this.state.hospitalData.length === 1
                    ? "footerContainer"
                    : this.state.hospitalData.length === 2
                      ? "footerContainer footerContainer2"
                      : this.state.hospitalData.length === 3
                        ? "footerContainer footerContainer3"
                        : "footerContainer footerContainer2"
                }
              >
                <div class="footerMenuList">
                  <div class="footerTitle">Contact Us</div>
                  <ul>
                    <li>
                      <i class="fa fa-map-marker" aria-hidden="true"></i>
                      <span>
                        {obj.address}, <br></br>
                        {obj.cityName}, &nbsp;
                        {obj.stateName}, &nbsp;
                        {obj.zipCode}
                      </span>
                    </li>
                    {obj.phone != "" && (
                      <li>
                        <a href="#">
                          <i class="fa fa-phone" aria-hidden="true"></i>
                          <span>{obj.phone}</span>
                        </a>
                      </li>
                    )}
                  </ul>
                </div>
                <div class="footerMenuList">
                  <div className="footerListSub mapDiv">
                    <iframe
                      src={
                        "https://maps.google.com/maps?q=" +
                        location +
                        "&ll=" +
                        obj.latitude +
                        "," +
                        obj.longitude +
                        "&z=15&output=embed"
                      }
                      width="100%"
                      height="200"
                      frameborder="0"
                      allowfullscreen=""
                    ></iframe>
                  </div>
                </div>
              </div>
            );
          })}

          <div class="footerContainerBottom pt-2">
            {window.sessionStorage.getItem("hospital_working_time") != "" ? (
              <div class="footerMenuList">
                <div class="footerTitle">Hours</div>
                <ul class="">
                  <li>
                    <span>
                      <InnerHTML
                        html={window.sessionStorage.getItem(
                          "hospital_working_time"
                        )}
                      />
                    </span>
                  </li>
                  <li></li>
                </ul>
              </div>
            ) : (
              ""
            )}

            {window.sessionStorage.getItem("contact_emailId") != "" ? (
              <div className="footerMenuList">
                <div class="footerTitle">Contact Email</div>
                <ul class="">
                  <li>
                    <span>
                      {window.sessionStorage.getItem("contact_emailId")}
                    </span>
                  </li>
                </ul>
              </div>
            ) : (
              ""
            )}

            {this.state.footerData.length > 0 ? (
              <div class="footerSocial footerMenuList">
                {this.state.footerData.map((obj) => {
                  return (
                    <div class="footerSocialSub">
                      {obj.name === "Instagram" && (
                        <a href={obj.url} title="Instagram" target="_blank">
                          <i class="fa fa-instagram" aria-hidden="true"></i>
                        </a>
                      )}
                      {obj.name === "Twitter" && (
                        <a href={obj.url} title="Twitter" target="_blank">
                          <i class="fa fa-twitter" aria-hidden="true"></i>
                        </a>
                      )}
                      {obj.name === "Youtube" && (
                        <a href={obj.url} title="Youtube" target="_blank">
                          <i class="fa fa-youtube" aria-hidden="true"></i>
                        </a>
                      )}
                      {obj.name === "Facebook" && (
                        <a href={obj.url} title="Facebook" target="_blank">
                          <i class="fa fa-facebook" aria-hidden="true"></i>
                        </a>
                      )}
                      {obj.name === "Pinterest" && (
                        <a href={obj.url} title="Pinterest" target="_blank">
                          <i class="fa fa-pinterest" aria-hidden="true"></i>
                        </a>
                      )}
                      {/* {obj.name === "Whatsapp" && (
                        <a
                          href={"tel:" + obj.content}
                          title={"Whatsapp:" + obj.content}
                          target="_blank"
                        >
                          <i class="fa fa-whatsapp" aria-hidden="true"></i>
                        </a>
                      )} */}
                      {obj.name === "Whatsapp" && (
                        <Whatsapp path={obj.url}></Whatsapp>
                        // <a href={obj.url} title={"Whatsapp"} target="_blank">
                        //   <i class="fa fa-whatsapp" aria-hidden="true"></i>
                        // </a>
                      )}
                    </div>
                  );
                })}
              </div>
            ) : (
              ""
            )}
          </div>
        </div>

        <div class="footerBottom footerBottomLink">
          <div className="container">
            <div className="footerBottomLeft">
              <a href={(urlPath, "/termsConditions")}>Terms and Conditions</a>{" "}
              <span className="px-1 m-0">|</span>
              <a href={(urlPath, "/privacyPolicy")}>Privacy Policy</a>
            </div>
            <div className="footerBottomRight">
              Copyright © {new Date().getFullYear()}{" "}
              {window.sessionStorage.getItem("siteName")}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
